import { Connection, Keypair, LAMPORTS_PER_SOL, PublicKey, SystemProgram, VersionedTransaction } from '@solana/web3.js';

export const use0Slot = () => {
    const connection0Slot = new Connection(`${process.env.REACT_APP_0SLOT_PROXY}`, 'confirmed');

    function get0SlotFeeInstruction(from: PublicKey, tipLamports: number) {
        console.log('tipLamports', tipLamports);
        if (tipLamports < 100000) throw new Error('Tip amount < 0.0001 SOL');
        if (tipLamports > LAMPORTS_PER_SOL) throw new Error('Tip amount > 1 SOL');

        const feeReceiver = new PublicKey('4HiwLEP2Bzqj3hM2ENxJuzhcPCdsafwiet3oGkMkuQY4');

        return SystemProgram.transfer({
            fromPubkey: from,
            toPubkey: feeReceiver,
            lamports: tipLamports + Math.floor(Math.random() * 1000),
        });
    }

    async function send0SlotTransaction(signedTransaction: VersionedTransaction) {
        const tx = await connection0Slot.sendRawTransaction(signedTransaction.serialize(), { skipPreflight: true });

        return tx;
    }

    return { get0SlotFeeInstruction, send0SlotTransaction };
};
